import { Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";

import { getStaffRoleColor } from "@/common/components/user-avatar/UserAvatar.utils";
import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import { useTranslation } from "@/translations";

import { getRoleLabelKey } from "./RoleChip.utils";

const CHIP_BACKGROUND_OPACITY = 0.25;

interface Props {
  role: UserPermission;
}

export function RoleChip({ role }: Props) {
  const { t } = useTranslation();

  return (
    <Chip
      size="small"
      label={t(getRoleLabelKey(role))}
      sx={(theme) => {
        const color = getStaffRoleColor(theme, role);
        return {
          bgcolor: alpha(color, CHIP_BACKGROUND_OPACITY),
          color,
          fontWeight: 600,
        };
      }}
    />
  );
}
